<div class="role-dialog__container">
  <h2>
    @if (roleHasId) {
      <mat-icon svgIcon="pencil-outline"></mat-icon>
      Edit Role
    } @else {
      <mat-icon svgIcon="plus"></mat-icon>
      Create Role
    }
  </h2>

  <div class="role-dialog__input-container">
    <oph-input-orange
      [control]="$any(roleFg.get('displayName'))"
      [inputStyle]="{height: '50px', fontSize: '16px'}"
      placeholder="Role name"
    />
    @if (roleFg.get('displayName')?.errors?.['duplicateName']) {
      <span class="role-dialog__error-message">A role with this name already exists.</span>
    }
  </div>

  <oph-dialog-footer
    [labels]="footerActionLabels()"
    [menuOptions]="menuOptions"
    [hideMenu]="!roleHasId"
    [loading]="isLoading"
    (cancel)="onCancel()"
    (save)="onSave()"
    (menuOption)="onMenuOption($event)"
  />
</div>
